export const ACTIVATION_BRIEF_STATUS_NONE = 'none';
export const ACTIVATION_BRIEF_STATUS_NEW = 'new';
export const ACTIVATION_BRIEF_STATUS_IN_REVIEW = 'in_review';
export const ACTIVATION_BRIEF_STATUS_PENDING_APPROVAL = 'pending_approval';
export const ACTIVATION_BRIEF_STATUS_ACCEPTED = 'accepted';
export const ACTIVATION_BRIEF_STATUS_DECLINED = 'declined';
export const ACTIVATION_BRIEF_STATUS_COMPLETE = 'complete';
export const ACTIVATION_BRIEF_STATUS_ARCHIVED = 'archived';
export const ACTIVATION_BRIEF_STATUS_LABELS = {
    [ACTIVATION_BRIEF_STATUS_NONE]: 'Not Activated',
    [ACTIVATION_BRIEF_STATUS_NEW]: 'New',
    [ACTIVATION_BRIEF_STATUS_IN_REVIEW]: 'In Review',
    [ACTIVATION_BRIEF_STATUS_PENDING_APPROVAL]: 'Pending Influencer Approval',
    [ACTIVATION_BRIEF_STATUS_ACCEPTED]: 'Activated',
    [ACTIVATION_BRIEF_STATUS_DECLINED]: 'Declined',
    [ACTIVATION_BRIEF_STATUS_COMPLETE]: 'Complete',
    [ACTIVATION_BRIEF_STATUS_ARCHIVED]: 'Archived'
};
export const ACTIVATION_BRIEF_STATUS_COLORS = {
    [ACTIVATION_BRIEF_STATUS_NONE]: 'basic',
    [ACTIVATION_BRIEF_STATUS_NEW]: 'primary',
    [ACTIVATION_BRIEF_STATUS_IN_REVIEW]: 'warning',
    [ACTIVATION_BRIEF_STATUS_PENDING_APPROVAL]: 'warning',
    [ACTIVATION_BRIEF_STATUS_ACCEPTED]: 'good',
    [ACTIVATION_BRIEF_STATUS_DECLINED]: 'warning',
    [ACTIVATION_BRIEF_STATUS_COMPLETE]: 'good',
    [ACTIVATION_BRIEF_STATUS_ARCHIVED]: 'basic'
};
export const ACTIVATION_BRIEF_TYPE_ONGOING = 'ongoing';
export const ACTIVATION_BRIEF_TYPE_SCHEDULED = 'scheduled';
export const ACTIVATION_BRIEF_TYPE_RECURRING = 'recurring';
